import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { type CreditUsageCategory, type CreditUsageStats } from '~/components/CreditUsageMeter/types';
import { CREDIT_USAGE_CATEGORIES, CREDIT_USAGE_CATEGORY_COLOR_MAP } from '~/components/CreditUsageMeter/utils';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';

const LABEL_MAP = {
  storage: 'Storage',
  smartStorage: 'Enrichment',
  generative: 'Generation',
} as const satisfies Record<CreditUsageCategory, string>;

export type CreditUsageMeterLegendProps = Pick<ComponentProps<'div'>, 'className'> & Pick<CreditUsageStats, 'used'>;

export const CreditUsageMeterLegend = memo(({ used, className }: CreditUsageMeterLegendProps) => {
  const { data: subscription } = useSubscriptionContext();

  return (
    <div className={cn('flex gap-2', className)}>
      {CREDIT_USAGE_CATEGORIES.map((category) => {
        if (!subscription?.isCreditModel && !used[category].credits && category !== 'generative') {
          return null;
        }

        return (
          <div className="flex items-center gap-1 text-12 text-gray-9" key={category}>
            <span className={cn('size-1.5 rounded-full', CREDIT_USAGE_CATEGORY_COLOR_MAP[category])} />
            {LABEL_MAP[category]}
          </div>
        );
      })}
    </div>
  );
});

CreditUsageMeterLegend.displayName = 'CreditUsageMeterLegend';
